module.exports = __webpack_public_path__ + "img/mingshi_xiangqing_yaoshi.aaa6554d.png";